// Recovered compiled webpack factory 307. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "createRenderParamsFromClient", {
      enumerable: !0,
      get: function () {
        return n;
      },
    }));
  let n = r(77370).createRenderParamsFromClient;
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
